import { CheckCircle, DoneAll } from '@mui/icons-material';
import { Alert, AlertTitle, Box, Paper, Typography } from '@mui/material';
import Question from '@/components/exercise/question';
import RichContent from '@/components/shared/rich-content';
import { useAuth } from '@/providers';
import type { Exercise } from '@/types';
import CircularProgressLabel from '../shared/circular-progress-label';

export default function Questions({ exercise }: { exercise: Exercise }) {
  const { isLoggedIn } = useAuth();
  const { id, questions, taskNode, status } = exercise;
  const result = status === 'submitted';
  const correctCount = questions?.filter((question) => question.correct).length;
  const total = questions?.length;
  const progress =
    total && total > 0 && correctCount ? Math.round((correctCount / total) * 100) : 0;

  return (
    <Box>
      {questions?.length === 0 && result && (
        <Alert severity="info">Du hast diese Übung nicht bearbeitet.</Alert>
      )}
      {questions &&
        questions?.length > 0 &&
        result &&
        (progress === 100 ? (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            action={<CircularProgressLabel value={progress} />}
            icon={<DoneAll />}>
            <AlertTitle>Ergebnis</AlertTitle>
            Super gemacht! Du hast {correctCount} von {total} Fragen in dieser Übung richtig
            beantwortet. 🎉
          </Alert>
        ) : (
          <Alert
            severity="info"
            sx={{ mb: 2 }}
            action={<CircularProgressLabel value={progress} />}
            icon={<CheckCircle />}>
            <AlertTitle>Ergebnis</AlertTitle>
            Du hast {correctCount} von {total} Fragen in dieser Übung richtig beantwortet.
          </Alert>
        ))}
      {taskNode && questions && questions.length > 0 && (
        <Paper elevation={2} sx={{ p: 3, mb: 3, userSelect: 'none' }}>
          <Typography variant="h2" mb={1}>
            Aufgabe
          </Typography>
          <RichContent content={taskNode} />
        </Paper>
      )}
      {questions &&
        questions.length > 0 &&
        questions.map((question, index: number) => (
          <Question
            index={index}
            preview={!isLoggedIn}
            result={status === 'submitted'}
            question={question}
            key={`${id}-${question.id}`}
          />
        ))}
    </Box>
  );
}
